// extracted by mini-css-extract-plugin
export default {"content":"ContactPage_content__uqoKb","map":"ContactPage_map__Aad3d","persons":"ContactPage_persons__U7Jng","persons_wrapper":"ContactPage_persons_wrapper__Zs8oe"};